import { Country, MaterialCreationProcess } from 'api';
import { MaterialComponentValueSchema } from 'features';
import { type InferType, yup } from 'form';

export const MaterialProductSchema = yup
  .object({
    buyer_material_component_values: yup
      .array()
      .of(MaterialComponentValueSchema)
      .required()
      .min(1, 'At least one buyer material component is required.'),
    country: yup.string().oneOf(Object.values(Country)).required(),
    creation_process: yup.string().oneOf(Object.values(MaterialCreationProcess)).optional(),
    has_caps_and_labels: yup.boolean().optional(),
    is_food_grade: yup.boolean().optional(),
    material_colour_id: yup.number().optional(),
    material_grade_id: yup.number().required(),
    material_id: yup.number().optional(),
    material_origin_id: yup.number().optional(),
    material_spec_id: yup.number().required(),
    seller_material_component_values: yup
      .array()
      .of(MaterialComponentValueSchema)
      .required()
      .min(1, 'At least one seller material component is required.'),
  })
  .test(
    'buyer-seller-material-component-values-length',
    'The number of buyer and seller material components values must be the same.',
    function (value) {
      const isSameLength =
        value.buyer_material_component_values?.length === value.seller_material_component_values?.length;
      if (!isSameLength) {
        return this.createError({
          message: 'The number of seller and buyer material components values must be the same.',
          path: 'seller_material_component_values',
        });
      }
      return true;
    }
  );

export type MaterialProductFormValues = InferType<typeof MaterialProductSchema>;
